import moment from 'moment-timezone'
import IndexController from '../index_controller'

export default class extends IndexController {
  connect () {
    super.connect()

    $('#logs').dropdown({})
    $('#report-templates').dropdown({})

    const accountsDropdown = $('#accounts')
    if (accountsDropdown.length) {
      accountsDropdown.dropdown({})
    }

    super.initializeFromToDateFilters()
  }

  buildFilters () {
    const filters = super.buildFilters()
    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].logs = $('#logs').dropdown('get values') || []
    filters.criteria[this.filterSetKeyPrefixValue + '_filters'].report_templates = $('#report-templates').dropdown('get values') || []
    if ($('#accounts').length) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].accounts = $('#accounts').dropdown('get values') || []
    }

    const accountTimezone = localStorage.getItem('accountTimezone')
    const rawFrom = $('#from-date-filter').data('datepicker').getDate()
    const fromDate = rawFrom ? moment.tz([rawFrom.getFullYear(), rawFrom.getMonth(), rawFrom.getDate()], accountTimezone) : moment.invalid()
    const rawTo = $('#to-date-filter').data('datepicker').getDate()
    const toDate = rawTo ? moment.tz([rawTo.getFullYear(), rawTo.getMonth(), rawTo.getDate()], accountTimezone).add(1, 'd').subtract(1, 's') : moment.invalid()

    if (fromDate && fromDate.isValid()) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].from_date = fromDate.unix()
    }

    if (toDate && toDate.isValid()) {
      filters.criteria[this.filterSetKeyPrefixValue + '_filters'].to_date = toDate.unix()
    }

    return filters
  }

  setUIFilterDefaults () {
    this.disableFilterEvents()
    $('#logs').dropdown('clear')
    $('#report-templates').dropdown('clear')
    if ($('#accounts').length) {
      $('#accounts').dropdown('clear')
    }
    $('#reports-search-input').val('')
    $('#from-date-filter').datepicker('clearDates')
    $('#to-date-filter').datepicker('clearDates')
    this.enableFilterEvents()
  }
}
